import { useState } from 'react'

const useManufacturerToggle = ({ name, address, onChange }) => {
  const hasManufacturerData = () => !!name || !!address

  const [isEnabled, setIsEnabled] = useState(hasManufacturerData)

  const handleToggle = e => {
    const { checked } = e.target

    setIsEnabled(checked)

    if (!checked) onChange({ manufacturer_name: null, manufacturer_address: null })
  }

  return { isEnabled, handleToggle }
}

export default useManufacturerToggle
